export class ApiBuilder {
    method = 'GET'; // POST|PUT|PATCH|DELETE
    body = {}; // Request Body
    headers = {
        'Content-Type': 'application/json'
    }; // Request Headers
    url = '';

    constructor(url) {
        this.url = url;
    }

    withMethod(m) {
        if (!['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].includes(m.toUpperCase())) {
            throw new Error(`Invalid request method ${m}. Only GET, POST, PUT, PATCH and DELETE are supported`);
        }
        this.method = m;
        return this;
    }

    get() {
        return this.withMethod('GET');
    }

    post() {
        return this.withMethod('POST');
    }

    put() {
        return this.withMethod('PUT');
    }

    patch() {
        return this.withMethod('PATCH');
    }

    delete() {
        return this.withMethod('DELETE');
    }

    withBody(b) {
        if (this.method.toUpperCase() === 'GET') {
            throw new Error('GET method can not have a body');
        }
        this.body = b;
        return this;
    } 

    withHeaders(h) {
        this.headers = h;
    }

    async send() {
        if (this.method.toUpperCase() === 'GET') {
            const response = await fetch(this.url, { method: 'GET' });
            return this.processResponse(response);
        }
        const response = await fetch(this.url, {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body)
        });
        return this.processResponse(response);
    }

    async processResponse(response) {
        if (!response.ok) {
            const res = await response.text();
            console.error(res);
            throw new Error(`Could not complete the request. Server returned non-OK response`);
        }
        return await response.json();
    }
}

